import styled from 'styled-components';

export const Iphone = styled.div`
  width: 300px;
  height: 564px;
  background: #fff;
  border-radius: 35px;
  box-shadow: inset 0 0 16px rgba(0,0,0, .1), 0 16px 32px rgba(0,0,0, .1);
  position: relative;

  > div {
    position: absolute;
    top: 16px;
    left: 16px;
    width: calc(100% - 32px);
    height: calc(100% - 32px);
    border-radius: 25px;
    box-shadow: inset 0 0 20px rgba(0,0,0, .2);
    background: #fff;
    overflow: hidden;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

  ${props => props.hero && `
    @media (min-width: 50rem) {
      width: 440px;
      height: 886px;

      > div {
        top: 32px;
        left: 32px;
        width: calc(100% - 64px);
        height: calc(100% - 64px);
        border-radius: 32px;
      }
    }

    &:after {
      display: none;
    }
  `}
`;
